<template>
    <v-col cols="12" :sm="sm" v-bind="$attrs">
        <v-switch
            v-model="model"
            :color="color"
            :disabled="disabled"
            inset
            dense
            hide-details
            hint="teste de texto"
            persistent-hint
        >
        <template v-slot:label>
            <emc-info-help v-if="textHelper" title="Informações" :text="textHelper" />
            {{ label }}
        </template>
    </v-switch>
    </v-col>
</template>

<script setup>

import { defineProps, computed, defineEmits } from 'vue'

const emit = defineEmits(['input'])

const props = defineProps({
    value: { type: [Boolean, Number], default: true },
    label: { type: String, required: false, default: 'Ativo' },
    disabled: { type: Boolean, default: false },
    color: { type: String, default: 'primary' },
    sm: { type: [Number, String], default: 1 },
    textHelper: { type: String, default: null },
})

const model = computed({
    get() {
        return props.value
    },
    set(val) {
        emit('input', val)
    }
})

</script>